import { useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { backgroundRefetchesVar } from 'state/vars';

// Drives the "Refreshing data" indicator. Call from a data hook with a flag that's true when it's
// showing cached data while a background refetch is still in flight,
// so the component responsible for the loading indicator knows to keep showing it.
export const useRegisterBackgroundRefetch = (isRefetching: boolean) => {
  const [id] = useState(() => Symbol());

  useEffect(() => {
    if (isRefetching) {
      const next = new Set(backgroundRefetchesVar());
      next.add(id);
      backgroundRefetchesVar(next);
    }

    return () => {
      const current = backgroundRefetchesVar();

      if (!current.has(id)) return;

      const next = new Set(current);
      next.delete(id);
      backgroundRefetchesVar(next);
    };
  }, [id, isRefetching]);
};

// True while at least one useRegisterBackgroundRefetch caller anywhere in the app is refetching
export const useIsBackgroundRefetching = () => {
  const activeRefetches = useReactiveVar(backgroundRefetchesVar);

  return activeRefetches.size > 0;
};
